import React from 'react';

export default function Table({ className = '', children }) {
  return (
    <div className="overflow-x-auto">
      <table className={`min-w-full text-sm ${className}`}>
        {children}
      </table>
    </div>
  );
}
